// import React, { useMemo } from "react";
// import { useMarket } from "../contexts/MarketContext";
// import {AccountProvider} from "../account-context";
// // import { AccountProvider } from "../../contexts/account-context";
// //import OperationalHealth from "../operational/OperationalHealth";
// //import "./MarketDashboard.css";

// import OperationalHealth from "../OperationalHealth";

// const MarketDashboard = () => {
//   const { 
//     selectedMarket, 
//     currentMarketConfig, 
//     accountId,
//     navigateToGlobal 
//   } = useMarket();

//   // Don't render if no market selected
//   if (!selectedMarket || !currentMarketConfig) {
//     return (
//       <div className="market-dashboard-error">
//         <p>No market selected. Please select a market from the global dashboard.</p>
//         <button onClick={navigateToGlobal}>
//           Go to Global Dashboard
//         </button>
//       </div>
//     );
//   }

//   console.log(`[MarketDashboard] Rendering for ${selectedMarket} (Account: ${accountId})`);

//   return (
//     <div className="market-dashboard">
//       {/* Market Header with Back Button */}
//       <div className="market-dashboard-header">
//         <button 
//           className="market-back-button"
//           onClick={navigateToGlobal}
//           aria-label="Back to Global Dashboard"
//         >
//           ← Back to Global
//         </button>
        
//         <div className="market-title-section">
//           <h1 className="market-title">
//             {currentMarketConfig.name} ({selectedMarket})
//           </h1>
//           <span className="market-subtitle">
//             Account ID: {accountId}
//           </span>
//         </div>
//       </div>

//       {/* Render OperationalHealth with market-specific accountId */}
//       <AccountProvider accountId={accountId}>
//         <OperationalHealth />
//       </AccountProvider>
//     </div>
//   );
// };

// export default MarketDashboard;

// import React from "react";
// import { useMarket } from "../contexts/MarketContext";
// import DashboardLayout from "../shared/DashboardLayout";

// const MarketDashboard = () => {
//   const { 
//     selectedMarket, 
//     currentMarketConfig, 
//     accountId,
//     navigateToGlobal,
//     isMarketView
//   } = useMarket();

//   if (!isMarketView || !selectedMarket || !currentMarketConfig) {
//     return null;
//   }

//   return (
//     <DashboardLayout 
//       mode="market"
//       marketCode={selectedMarket}
//       marketName={currentMarketConfig.name}
//       accountId={accountId}
//       onBackClick={navigateToGlobal}
//     />
//   );
// };

// export default MarketDashboard;

import React from "react";
import { useMarket } from "../contexts/MarketContext";
import { AccountProvider } from "../account-context";
import DashboardLayout from "../shared/DashboardLayout";
//import "../../styles/MarketDashboard.css";

/**
 * MarketDashboard Component
 * Shows details for a specific market
 */
const MarketDashboard = ({ userEmail, language, setLanguage }) => {
  const { 
    selectedMarket, 
    currentMarketConfig, 
    accountId,
    navigateToGlobal,
    isMarketView
  } = useMarket();

  console.log(`[MarketDashboard] Market: ${selectedMarket}, AccountId: ${accountId}, User: ${userEmail}`);

  // Guard: only render if market view with valid selection
  if (!isMarketView || !selectedMarket || !currentMarketConfig) {
    return (
      <div className="market-dashboard-error">
        <h2>No Market Selected</h2>
        <p>Please select a market from the global dashboard.</p>
        <button className="error-back-button" onClick={navigateToGlobal}>
          Go to Global Dashboard
        </button>
      </div>
    );
  }

  return (
    <div className="market-dashboard">
      {/* Wrap with AccountProvider to pass market-specific accountId */}
      <AccountProvider 
        accountId={accountId}
        userEmail={userEmail}
        language={language}
        setLanguage={setLanguage}
      >
        <DashboardLayout 
          mode="market"
          marketCode={selectedMarket}
          marketName={currentMarketConfig.name}
          accountId={accountId}
          onBackClick={navigateToGlobal}
        />
      </AccountProvider>
    </div>
  );
};

export default MarketDashboard;